// components/Outreach/RepliesTab.js — обновлён: worker обязателен всегда
import React, { useState, useEffect } from "react";
import { getCookie } from "../../services/cookie";

const API_BASE = "https://flautreach.com/flautreach/api/outreach";

export function RepliesTab({ add }) {
  const token = () => getCookie("authToken");
  const getHeaders = () => {
    const t = token();
    return { "Content-Type": "application/json", ...(t ? { Authorization: `Bearer ${t}` } : {}) };
  };

  const [contactType, setContactType] = useState("EMAIL");
  const [email, setEmail] = useState("");
  const [fbUrl, setFbUrl] = useState("");
  const [contactEmail, setContactEmail] = useState("");
  const [replyText, setReplyText] = useState("");
  const [replies, setReplies] = useState([]);
  const [creating, setCreating] = useState(false);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [executionsList, setExecutionsList] = useState([]);
  const [selectedExecId, setSelectedExecId] = useState("");
  const [searching, setSearching] = useState(false);

  const [workers, setWorkers] = useState([]);
  const [selectedWorker, setSelectedWorker] = useState("");

  useEffect(() => { loadReplies(); loadWorkers(); }, [page]);

  const loadReplies = async () => {
    try {
      const resp = await fetch(`${API_BASE}/replies/?page=${page}&page_size=10`, { headers: getHeaders() });
      if (resp.ok) {
        const data = await resp.json();
        setReplies(data.results || data || []);
        setTotalPages(data.pagination?.total_pages || 1);
      }
    } catch {}
  };

  const loadWorkers = async () => {
    try {
      const resp = await fetch(`${API_BASE}/workers/?page_size=100`, { headers: getHeaders() });
      if (resp.ok) {
        const data = await resp.json();
        const list = Array.isArray(data) ? data : data.results || [];
        setWorkers(list.filter(w => w.is_active));
      }
    } catch {}
  };

  const resetForm = (newType) => {
    setContactType(newType);
    setExecutionsList([]);
    setSelectedExecId("");
  };

  // Поиск – теперь требует воркера всегда
  const handleSearch = () => {
    setExecutionsList([]);
    setSelectedExecId("");

    let searchValue = "";
    if (contactType === "EMAIL") {
      if (!email.trim()) { add?.("Введи email", "error"); return; }
      searchValue = email.trim();
    } else if (contactType === "FB_MESSENGER") {
      if (!fbUrl.trim()) { add?.("Введи URL", "error"); return; }
      searchValue = fbUrl.trim();
    } else if (contactType === "CONTACT_FORM") {
      if (!contactEmail.trim()) { add?.("Введи email", "error"); return; }
      searchValue = contactEmail.trim();
    }
    if (!selectedWorker) { add?.("Выбери воркера", "error"); return; }

    setSearching(true);
    const params = new URLSearchParams({
      contact: searchValue,
      contact_type: contactType,
      worker_name: selectedWorker,
    });

    fetch(`${API_BASE}/executions/find_by_contact/?${params}`, { headers: getHeaders() })
      .then(resp => resp.json())
      .then(data => {
        const execs = data.executions || [];
        if (execs.length === 0) {
          add?.(data.error || "Диалоги не найдены", "error");
        } else {
          setExecutionsList(execs);
          setSelectedExecId(execs[0].execution_id);
        }
      })
      .catch(() => add?.("Ошибка поиска", "error"))
      .finally(() => setSearching(false));
  };

  // Автопоиск только когда всё заполнено
  useEffect(() => {
    if (contactType === "EMAIL" && email.trim().includes("@") && selectedWorker) {
      const timer = setTimeout(handleSearch, 700);
      return () => clearTimeout(timer);
    }
  }, [email, selectedWorker, contactType]);

  useEffect(() => {
    if (contactType === "FB_MESSENGER" && fbUrl.trim().length > 5 && selectedWorker) {
      const timer = setTimeout(handleSearch, 700);
      return () => clearTimeout(timer);
    }
  }, [fbUrl, selectedWorker, contactType]);

  const addReply = async () => {
    if (!replyText.trim()) { add?.("Введи текст ответа", "error"); return; }

    let contactValue = "";
    if (contactType === "EMAIL") {
      if (!email.trim()) { add?.("Введи email", "error"); return; }
      contactValue = email.trim();
    } else if (contactType === "FB_MESSENGER") {
      if (!fbUrl.trim()) { add?.("Введи URL", "error"); return; }
      contactValue = fbUrl.trim();
    } else if (contactType === "CONTACT_FORM") {
      if (!contactEmail.trim()) { add?.("Введи email", "error"); return; }
      contactValue = contactEmail.trim();
    }
    if (!selectedWorker) { add?.("Выбери воркера", "error"); return; }
    if (!selectedExecId) { add?.("Не выбран execution", "error"); return; }

    setCreating(true);
    try {
      const resp = await fetch(`${API_BASE}/replies/`, {
        method: "POST",
        headers: getHeaders(),
        body: JSON.stringify({
          execution_id: parseInt(selectedExecId),
          text: replyText.trim(),
          contact_type: contactType,
          contact_value: contactValue,
        }),
      });

      if (resp.ok) {
        add?.("✅ Ответ добавлен", "success");
        setReplyText("");
        setEmail("");
        setFbUrl("");
        setContactEmail("");
        setExecutionsList([]);
        setSelectedExecId("");
        loadReplies();
      } else {
        const err = await resp.json().catch(() => ({}));
        add?.(err.detail || JSON.stringify(err) || "Ошибка", "error");
      }
    } catch (err) {
      add?.("Ошибка: " + err.message, "error");
    } finally {
      setCreating(false);
    }
  };

  const deleteReply = async (id) => {
    if (!window.confirm(`Удалить ответ #${id}?`)) return;
    try {
      await fetch(`${API_BASE}/replies/${id}/`, { method: "DELETE", headers: getHeaders() });
      add?.("Ответ удалён", "info");
      loadReplies();
    } catch (err) {
      add?.("Ошибка", "error");
    }
  };

  const contactTypes = [
    { value: "EMAIL", label: "📧 Email" },
    { value: "FB_MESSENGER", label: "💬 FB Messenger" },
    { value: "CONTACT_FORM", label: "📝 Contact Form" },
  ];

  return (
    <div>
      <div className="section-card" style={{ marginBottom: 20 }}>
        <h3>📥 Добавить входящий ответ</h3>

        <div className="form-group">
          <label className="form-label">Тип контакта</label>
          <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
            {contactTypes.map(ct => (
              <button
                key={ct.value}
                className={`channel-tab ${contactType === ct.value ? "active" : ""}`}
                onClick={() => resetForm(ct.value)}
              >
                {ct.label}
              </button>
            ))}
          </div>
        </div>

        {/* Выбор воркера (общий для всех) */}
        <div className="form-group">
          <label className="form-label">👷 Выбери воркера *</label>
          <select
            className="form-input"
            style={{ paddingLeft: 14 }}
            value={selectedWorker}
            onChange={e => {
              setSelectedWorker(e.target.value);
              setExecutionsList([]);
              setSelectedExecId("");
            }}
          >
            <option value="">-- Выбери воркера --</option>
            {workers.map(w => (
              <option key={w.id} value={w.name}>
                {w.name} (лимит: {w.daily_limit || "—"})
              </option>
            ))}
          </select>
        </div>

        {/* Поля контакта */}
        {contactType === "EMAIL" && (
          <div className="form-group">
            <label className="form-label">Email отправителя *</label>
            <div style={{ display: "flex", gap: 8 }}>
              <input
                className="form-input"
                style={{ paddingLeft: 14, flex: 1 }}
                value={email}
                onChange={e => { setEmail(e.target.value); setExecutionsList([]); setSelectedExecId(""); }}
                placeholder="user@example.com"
              />
              <button className="btn-add" onClick={handleSearch} disabled={searching || !email.trim() || !selectedWorker}>
                {searching ? "⏳" : "🔍"} Найти
              </button>
            </div>
          </div>
        )}

        {contactType === "FB_MESSENGER" && (
          <div className="form-group">
            <label className="form-label">URL Facebook *</label>
            <div style={{ display: "flex", gap: 8 }}>
              <input
                className="form-input"
                style={{ paddingLeft: 14, flex: 1 }}
                value={fbUrl}
                onChange={e => { setFbUrl(e.target.value); setExecutionsList([]); setSelectedExecId(""); }}
                placeholder="https://www.facebook.com/..."
              />
              <button className="btn-add" onClick={handleSearch} disabled={searching || !fbUrl.trim() || !selectedWorker}>
                {searching ? "⏳" : "🔍"} Найти
              </button>
            </div>
          </div>
        )}

        {contactType === "CONTACT_FORM" && (
          <div className="form-group">
            <label className="form-label">Email отправителя *</label>
            <div style={{ display: "flex", gap: 8 }}>
              <input
                className="form-input"
                style={{ paddingLeft: 14, flex: 1 }}
                value={contactEmail}
                onChange={e => { setContactEmail(e.target.value); setExecutionsList([]); setSelectedExecId(""); }}
                placeholder="user@example.com"
              />
              <button className="btn-add" onClick={handleSearch} disabled={searching || !contactEmail.trim() || !selectedWorker}>
                {searching ? "⏳" : "🔍"} Найти
              </button>
            </div>
          </div>
        )}

        {executionsList.length > 0 && (
          <div className="form-group">
            <label className="form-label">
              {executionsList.length === 1 ? "✅ Диалог" : `Найдено ${executionsList.length} диалогов`}
            </label>
            <select
              className="form-input"
              style={{ paddingLeft: 14 }}
              value={selectedExecId}
              onChange={e => setSelectedExecId(e.target.value)}
            >
              {executionsList.map(ex => (
                <option key={ex.execution_id} value={ex.execution_id}>
                  #{ex.execution_id} · 🤖 {ex.worker_name} · {ex.campaign_name} · {ex.target_name || ex.target_url?.substring(0, 30)} · {new Date(ex.exec_created).toLocaleString()}
                </option>
              ))}
            </select>
          </div>
        )}

        <div className="form-group">
          <label className="form-label">Текст ответа *</label>
          <textarea
            className="intent-textarea"
            style={{ minHeight: 80 }}
            value={replyText}
            onChange={e => setReplyText(e.target.value)}
            placeholder="Текст входящего ответа..."
          />
        </div>

        <button
          className="btn-primary"
          style={{ width: "auto", padding: "13px 32px" }}
          disabled={creating || !selectedExecId || !replyText.trim()}
          onClick={addReply}
        >
          {creating ? "⏳" : "→"} Добавить ответ
        </button>
      </div>

      <div className="section-card">
        <h3>Последние ответы</h3>
        <div className="rules-grid" style={{ marginTop: 12 }}>
          {replies.length === 0 ? (
            <div className="empty-state" style={{ padding: 20 }}><p>Нет ответов</p></div>
          ) : (
            replies.map(r => (
              <div key={r.id} className="rule-card" style={{ padding: "14px 18px" }}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
                  <div style={{ flex: 1 }}>
                    <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 4 }}>
                      <strong>#{r.id}</strong>
                      <span style={{
                        fontSize: 11, padding: "2px 8px", borderRadius: 8,
                        background: r.contact_type === "EMAIL" ? "#dbeafe" : r.contact_type === "FB_MESSENGER" ? "#dcfce7" : "#fef3c7",
                        color: r.contact_type === "EMAIL" ? "#1e40af" : r.contact_type === "FB_MESSENGER" ? "#166534" : "#92400e",
                      }}>
                        {r.contact_type === "EMAIL" ? "📧" : r.contact_type === "FB_MESSENGER" ? "💬" : "📝"} {r.contact_type || "EMAIL"}
                      </span>
                    </div>
                    <div style={{ fontSize: 12, color: "var(--muted)" }}>
                      {r.email && `📧 ${r.email}`}
                      {r.fb_url && `💬 ${r.fb_url?.substring(0, 40)}`}
                      {r.contact_value && !r.email && !r.fb_url && `📝 ${r.contact_value}`}
                      {" · "}Exec #{r.execution_id}
                      {" · "}📅 {new Date(r.created_at).toLocaleString()}
                    </div>
                    <p style={{ fontSize: 12, marginTop: 4 }}>{(r.reply_text || r.text || "").substring(0, 100)}</p>
                  </div>
                  <button className="btn-delete" onClick={() => deleteReply(r.id)}>🗑</button>
                </div>
              </div>
            ))
          )}
        </div>
        {totalPages > 1 && (
          <div style={{ display: "flex", justifyContent: "center", gap: 8, marginTop: 16 }}>
            <button disabled={page <= 1} onClick={() => setPage(p => p - 1)}>←</button>
            <span style={{ fontSize: 13, color: "var(--muted)" }}>{page} / {totalPages}</span>
            <button disabled={page >= totalPages} onClick={() => setPage(p => p + 1)}>→</button>
          </div>
        )}
      </div>
    </div>
  );
}